import script from "./PgmSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./PgmSwitch.vue?vue&type=script&setup=true&lang=js"

import "./PgmSwitch.vue?vue&type=style&index=0&id=38ed147b&lang=css"

const __exports__ = script;

export default __exports__